// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__pLAhx","connector":"styles_connector__J6DS5","label":"styles_label__hIz7I"};